import api from '@src/api';

export const getCourseAnnouncements = (payload) =>
  api.get(`course/${payload.course_id}/announcements`);
